import Head from "next/head";
import { useMemo } from "react";
import cn from "classnames";

import Typography from "@mui/material/Typography";

import CMSLogic from "@/src/logic/CMSLogic";
import { StrapiComponentType } from "@/src/type";
import { UUIDHelper } from "@/src/util";
import TrackingLogic from "@/src/logic/TrackingLogic";

interface TextBreakpointModuleProps {
  text?: StrapiComponentType.Element.TextBreakpoint;
  stylePrefix?: string;
  id: number | string;
  className?: string;
  classPrefix?: string;
  sectionTypePath?: string;
}

function TextBreakpointModule({ text, classPrefix, id, stylePrefix, className, sectionTypePath }: TextBreakpointModuleProps) {
  const name = useMemo(() => `${stylePrefix ?? "TextModule"}_${classPrefix ?? id ?? UUIDHelper.createUUID(true)}`, [stylePrefix, classPrefix, id]);
  const style = CMSLogic.generateTextBreakpointStyle(name, text?.breakpoints);
  const breaks = (text?.text ?? "").split("\n");

  if (!text || !text.id) {
    return <></>;
  }

  const componentId = sectionTypePath
    ? TrackingLogic.constructComponentId({ sectionTypePath, componentType: "element.text-breakpoint", componentId: text.id })
    : undefined;
  return (
    <>
      {style && (
        <Head>
          <style
            id={`TextBreakpointModule.${name}`}
            type="text/css"
            dangerouslySetInnerHTML={{ __html: style }}
          />
        </Head>
      )}
      {/* @ts-ignore */}
      <Typography
        id={id}
        className={cn(className, name)}
        variant={text?.tag}
        component-id={componentId}
      >
        {breaks.map((text, i) => (
          <span key={i}>
            {text}
            <br />
          </span>
        ))}
      </Typography>
    </>
  );
}

export default TextBreakpointModule;
